import React, { useContext } from "react";
import { IoReturnUpBackSharp } from "react-icons/io5";
import { AppContext } from "../../context";

function BackBtn({ history }) {
  const info = useContext(AppContext);
  return (
    history.length > 2 && (
      <button
        className="ahp-button"
        type="button"
        onClick={history.goBack}
        style={{ marginT: "1rem" }}
      >
        <IoReturnUpBackSharp /> {info.t("back")}
      </button>
    )
  );
}

export default BackBtn;
